/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown>, level: NonNullable<unknown> }} Following_Status_LevelInputs */

const en_following_status_level = /** @type {(inputs: Following_Status_LevelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status: ${i?.status} · ${i?.level}`)
};

/**
* | output |
* | --- |
* | "Status: {status} · {level}" |
*
* @param {Following_Status_LevelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_status_level = /** @type {((inputs: Following_Status_LevelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_Status_LevelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_status_level(inputs)
});